import * as React from "react";
import { Button, Icon } from "@vebox/etui-core";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";
import { capitalizeFirstLetter } from "../../../../../ReadAndWrite/ReadAndWrite/utils";
import { LoadingButton } from "../../../../../components/buttons/LoadingButton";

declare var AppTranslations: AppTranslations;

interface DefineEquipmentCardFooterProps {
	onReset: () => void;
	onNext: () => void;
	disabled?: boolean;
	onAdd: () => void;
	onImport: () => void;
	disableActionsButtons?: boolean;
	disableReset?: boolean;
	isResetLoading?: boolean;
}

export const DefineEquipmentCardFooter: React.FC<
	DefineEquipmentCardFooterProps
> = ({
	onNext,
	onReset,
	disabled,
	onAdd,
	onImport,
	disableActionsButtons,
	disableReset,
	isResetLoading,
}) => {
	return (
		<div className={"form-card-footer flx-row flx-space-between"}>
			<div className={"flx-row gap-15"}>
				<Button
					variant={"strong"}
					onClick={onAdd}
					iconProps={{ symbol: "add", weight: "400" }}
					disabled={disableActionsButtons}
				>
					{capitalizeFirstLetter(AppTranslations.genericWords.add)}
				</Button>
				<Button
					variant={"strong"}
					onClick={onImport}
					iconProps={{ symbol: "upload_file", weight: "400" }}
					disabled={disableActionsButtons}
				>
					{AppTranslations.genericWords.importTitle}
				</Button>
				<LoadingButton
					variant={"tertiary"}
					onClick={onReset}
					disabled={disableActionsButtons || disableReset}
					loading={isResetLoading}
				>
					<Icon symbol={"delete"} weight={"400"} />
					{AppTranslations.genericWords.removeAll}
				</LoadingButton>
			</div>
			<div className={"flx-row gap-15"}>
				<Button variant={"strong"} onClick={onNext} disabled={disabled}>
					{AppTranslations.genericWords.submit}
				</Button>
			</div>
		</div>
	);
};
